import AddIcon from '@mui/icons-material/Add';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Skeleton,
  Stack,
  styled,
  Typography
} from '@mui/material';
// import SampleCardIcon from 'assets/instaview/sampleCreditCard.svg';
import CannotDeleteDefaultCardPopup from 'components/PopUps/CannotDeleteDefaultCardPopup';
import { PRODUCT_TYPE } from 'configs/constants';
import InstavisionButton from 'coreComponents/Button/Button';
import InstaCard from 'coreComponents/InstaCard';
import MenuPopup from 'coreComponents/MenuPopup';
import PopUp from 'coreComponents/PopUp/Drawer';
import analyticsService, {
  AppEvent
} from 'infrastructure/serviceHandlers/Analytics/Analytics';
import PaymentScreenDemo from 'pages/PaymentScreen/PaymentScreen.demo';
import { partnerAssets } from 'partners/partnersAssets';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DeletePaymentMethod,
  UpdateDefaultPaymentMethod
} from 'services/api/paymentsApi';
import { changePaymentMethodInSubscription } from 'services/api/subscriptionApi';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchPaymentMethods } from 'store/reducers/paymentMethodsReducers';
import { fetchAllSubscription } from 'store/reducers/subscriptionReducer';
import { Image } from 'styles';
import {
  SUBSCRIPTION_TYPE,
  TCard,
  TPaymentMethodsState,
  TSubScriptionState,
  TSubscriptionType
} from 'typings';
import { PopupTypes } from 'typings/popUpTypes';
import { getCardImageProps } from 'utils/commonFunctions';
import { isRunningInWebView } from 'utils/webviewHelpers';

const MenuWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: '8px 12px',
  '&:hover': {
    color: '#000000',
    background: '#bdbdbd'
  }
});

function PaymentMethod({
  handleUpdateDefaultCard,
  onAddNewCardToggle,
  showAddNewCardButton = true,
  productType
}: {
  handleUpdateDefaultCard?: (cardId: string) => void;
  onAddNewCardToggle?: (isOpen: boolean) => void;
  showAddNewCardButton?: boolean;
  productType: string;
}) {
  const dispatch = useAppDispatch();
  const {
    homeSecuritySubscriptionList,
    birdSubscriptionList,
    defaultPaymentMethod,
    birdDefaultPaymentMethod
  } = useAppSelector(
    (state) => (state.subscription as TSubScriptionState) || []
  );

  const [subscriptionDataByProductType, setSubscriptionDataByProductType] =
    useState<TSubscriptionType[]>([]);

  const [defaultCardByProductType, setDefaultCardByProductType] =
    useState<TCard | null>();

  console.log('subscriptionDataByProductType', subscriptionDataByProductType);

  useEffect(() => {
    const subscriptionData =
      productType === PRODUCT_TYPE.HOME_SECURITY
        ? homeSecuritySubscriptionList
        : birdSubscriptionList;
    setSubscriptionDataByProductType(subscriptionData);

    const subscriptionCard =
      productType === PRODUCT_TYPE.HOME_SECURITY
        ? defaultPaymentMethod
        : birdDefaultPaymentMethod;

    setDefaultCardByProductType(subscriptionCard);
  }, [
    birdDefaultPaymentMethod,
    birdSubscriptionList,
    defaultPaymentMethod,
    homeSecuritySubscriptionList,
    productType
  ]);

  const { allPaymentMethods, isLoading: isPaymentMethodsLoading } =
    useAppSelector(
      (state) => (state.paymentMethods as TPaymentMethodsState) || []
    );

  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.subscription.subscriptionList'
  });

  const [selectedCardId, setSelectedCardId] = useState('');
  const [isNewCardModalOpen, setIsNewCardModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [
    cannotDeleteDefaultCardModelOpen,
    setCannotDeleteDefaultCardModelOpen
  ] = useState(false);
  const [deleteCardId, setDeleteCardId] = useState('');

  // const addNewPaymentMethod = () => {
  //   setIsNewCardModalOpen(true);
  // };

  useEffect(() => {
    if (isRunningInWebView() && onAddNewCardToggle) {
      onAddNewCardToggle(isNewCardModalOpen);
    }
  }, [isNewCardModalOpen, onAddNewCardToggle]);

  const fetchSavedCards = useCallback(() => {
    dispatch(fetchPaymentMethods());
  }, [dispatch]);

  useEffect(() => {
    analyticsService.trackEvent(AppEvent.PAYMENT_METHOD_SCREEN);
    fetchSavedCards();
  }, [dispatch, fetchSavedCards]);

  // useEffect(() => {
  //   dispatch(setDefaultPaymentMethod(allPaymentMethods[0] || null));
  // }, [allPaymentMethods, dispatch]);

  const handleCreditCardChange = async (
    cardId: string,
    newlyAdded?: boolean
  ) => {
    //  Make API call to update payment method
    const payload = {
      stripe_payment_method: cardId
    };

    UpdateDefaultPaymentMethod(cardId).then(() => {
      setSelectedCardId(cardId);
      if (handleUpdateDefaultCard) {
        // update selected payment id in parent component ( Review Purchase)
        handleUpdateDefaultCard(cardId);
      }
    });
    // if subscriptionData is empty, no need to update the subscription
    if (subscriptionDataByProductType?.length === 0) {
      return;
    }
    changePaymentMethodInSubscription(
      subscriptionDataByProductType[0]?.id,
      payload
    )
      .then(() => {
        dispatch(fetchAllSubscription());
      })
      .catch((err) => {
        // TODO: Add failure toast message
        console.error(err);
      });

    if (newlyAdded) {
      fetchSavedCards();
    }

    // Note: Data is not reloaded here.
    // The actual change occurs in the Piggyback service.
    // Subscription data is sourced from the Atlas service.
    // It may take a few seconds for changes to reflect in the other service.
  };

  const handleDeleteCard = (cardId: string) => {
    DeletePaymentMethod(cardId)
      .then(() => {
        console.log('edit');
        fetchSavedCards();
        dispatch(fetchAllSubscription());
      })
      .catch((err) => {
        console.error('Error deleting payment method: ', err);
      })
      .finally(() => {
        setDeleteCardId('');
        setIsDeleteModalOpen(false);
      });
  };

  useEffect(() => {
    if (allPaymentMethods.length > 0) {
      // Try to find a card from subscription list data card_details first, then from subscriptionCard
      let selectedCard = allPaymentMethods.find(
        (el) =>
          el.id === subscriptionDataByProductType?.[0]?.card_details?.id ||
          el.id === defaultCardByProductType?.id
      );

      if (!selectedCard) {
        selectedCard = allPaymentMethods.find(
          (el) =>
            el.card.exp_month === defaultCardByProductType?.exp_month &&
            el.card.exp_year === defaultCardByProductType?.exp_year &&
            el.card.last4 === defaultCardByProductType?.last4
        );
      }

      const id = selectedCard?.id || allPaymentMethods[0]?.id || '';
      setSelectedCardId(id);
    }
  }, [
    allPaymentMethods,
    defaultCardByProductType?.exp_month,
    dispatch,
    subscriptionDataByProductType
  ]);

  // useEffect(() => {
  //   if (subscriptionCard === undefined) {
  //     return;
  //   }

  //   // Check if there's a card that matches the subscriptionCard id
  //   let selectedCard = allPaymentMethods.find(
  //     (el: {
  //       id: string;
  //       card: {
  //         exp_month: number;
  //         exp_year: number;
  //         last4: string;
  //       };
  //     }) => el.id === subscriptionCard?.id
  //   );

  //   // Note: old cards in subscription api's card details object may not have id
  //   // for such cases match last 4 digits and expiry details to find the card

  //   if (!selectedCard) {
  //     selectedCard = allPaymentMethods.find(
  //       (el: {
  //         id: string;
  //         card: {
  //           exp_month: number;
  //           exp_year: number;
  //           last4: string;
  //         };
  //       }) =>
  //         el.card.exp_month === subscriptionCard?.exp_month &&
  //         el.card.exp_year === subscriptionCard?.exp_year &&
  //         el.card.last4 === subscriptionCard?.last4
  //     );
  //   }

  //   const id = selectedCard?.id || ''; // Default to empty string if no match
  //   // console.log('selected card', id);
  //   setSelectedCardId(id);
  // }, [allPaymentMethods, subscriptionData]);

  // this function checks if the card is default for any subsctiption ( home or bird )

  const checkIfDefaultCard = (cardId: string, closeMenu: () => void) => {
    if (
      cardId === birdSubscriptionList[0]?.card_details?.id ||
      cardId === homeSecuritySubscriptionList[0]?.card_details?.id
    ) {
      console.log(
        !!(
          birdSubscriptionList[0]?.card_details?.id ||
          homeSecuritySubscriptionList[0]?.card_details?.id
        )
      );
      console.log(
        'birdSubscriptionList[0]?.card_details?.id',
        birdSubscriptionList[0]?.card_details?.id
      );
      console.log(
        'homeSecuritySubscriptionList[0]?.card_details?.id',
        homeSecuritySubscriptionList[0]?.card_details?.id
      );
      setCannotDeleteDefaultCardModelOpen(true);
      return;
    }
    closeMenu();
    setDeleteCardId(cardId);
    setIsDeleteModalOpen(true);
  };

  if (isPaymentMethodsLoading)
    return (
      <>
        <Skeleton
          variant="rounded"
          height={32}
          animation="pulse"
          sx={{ borderRadius: '8px', marginBottom: '16px' }}
        />
        <Skeleton
          variant="rounded"
          height={200}
          animation="pulse"
          sx={{ borderRadius: '20px', marginBottom: '16px' }}
        />
      </>
    );

  return (
    <div>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        marginBottom="16px"
      >
        <Typography variant="label2" textTransform="uppercase">
          {t('paymentMethod')}
        </Typography>
      </Stack>
      {allPaymentMethods?.length > 0 && (
        <InstaCard styles={{ padding: '0px 12px' }}>
          {allPaymentMethods.map(
            (el: {
              id: string;
              card: {
                id: string;
                brand: string;
                last4: string;
                exp_month: number;
                exp_year: number;
              };
            }) => {
              const {
                id,
                card: { last4, brand, exp_month, exp_year }
              } = el;
              const { src, width, height } = getCardImageProps(brand);

              return (
                <Box
                  key={id}
                  sx={{
                    justifyContent: 'space-between',
                    width: '100%',
                    margin: (theme) => theme.spacing(2, 0)
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    gap={3}
                    justifyContent="space-between"
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      gap={2}
                      width="100%"
                    >
                      <Image src={src} width={width} height={height} />
                      <Stack gap={1} width="100%">
                        <Typography variant="body1">
                          **** **** **** {last4}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                        >{`${t(
                          'expiryDate'
                        )} ${exp_month}/${exp_year}`}</Typography>
                        {id === selectedCardId && (
                          <Typography variant="body2" color="primary.main">
                            {t('cardUseNote')}
                          </Typography>
                        )}
                      </Stack>
                    </Stack>
                    {allPaymentMethods?.length > 1 && (
                      <MenuPopup
                        sx={{
                          paddingLeft: '12px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'flex-start',
                          cursor: 'pointer'
                        }}
                        disablePopperButton={id === selectedCardId}
                        render={({ handleClose }) => {
                          return (
                            <>
                              <MenuWrapper
                                onClick={() => {
                                  handleCreditCardChange(id);
                                  handleClose();
                                }}
                              >
                                <Typography variant="body1">
                                  {t('makeDefault')}
                                </Typography>
                              </MenuWrapper>
                              <MenuWrapper
                                onClick={() =>
                                  checkIfDefaultCard(id, handleClose)
                                }
                              >
                                <Typography variant="body1">
                                  {t('deleteCard')}
                                </Typography>
                              </MenuWrapper>
                            </>
                          );
                        }}
                      />
                    )}
                  </Stack>
                </Box>
              );
            }
          )}
        </InstaCard>
      )}
      {/* <Button
        variant="text"
        onClick={addNewPaymentMethod}
        sx={{
          paddingLeft: '4px',
          marginTop: 0,
          paddingTop: 0,
          fontSize: '16px',
          width: 'fit-content'
        }}
      >
        + {t('addNewCard')}
      </Button> */}
      {showAddNewCardButton && (
        <InstaCard styles={{ padding: '0px', marginBottom: '8px' }}>
          <Accordion
            disableGutters
            square
            elevation={0}
            sx={{
              '&:before': { display: 'none' },
              backgroundColor: 'transparent',
              boxShadow: 'none',
              padding: '8px 12px'
            }}
          >
            <AccordionSummary
              expandIcon={<AddIcon />}
              sx={{
                padding: '0 4px 0 0',
                textAlign: 'left',
                wordSpacing: '0.02em'
              }}
            >
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                gap={3}
              >
                <img
                  src={partnerAssets.sampleCreditCardIcon}
                  alt="sample-card"
                  width="32"
                />
                <Typography variant="CTA2">{t('addNewCard')}</Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: '12px 0',
                textAlign: 'left',
                wordSpacing: '0.02em',
                marginTop: 0
              }}
            >
              <PaymentScreenDemo
                isUpgrade={false}
                isFreeTrial={false}
                amount={-1}
                submitPurchaseRequest={(cardId: string) => {
                  handleCreditCardChange(cardId, true);
                  setIsNewCardModalOpen(false);
                }}
                isPreviewPlan={
                  subscriptionDataByProductType[0]?.subscription_type ===
                  SUBSCRIPTION_TYPE.PREVIEW
                }
              />
            </AccordionDetails>
          </Accordion>
        </InstaCard>
      )}

      {/* <PopUp
        isOpen={isNewCardModalOpen}
        onPopUpCloseClick={() => {
          setIsNewCardModalOpen(false);
          setDeleteCardId('');
        }}
        cross
        type={PopupTypes.TYPE2}
        dialogProps={{
          scroll: 'body'
        }}
      >
        <Stack>
          <Typography variant="h3" marginX="auto" marginBottom="36px">
            {t('addCardDetails')}
          </Typography>
        </Stack>
        <PaymentScreenDemo
          isUpgrade={false}
          isFreeTrial={false}
          amount={-1}
          submitPurchaseRequest={(cardId: string) => {
            handleCreditCardChange(cardId, true);
            setIsNewCardModalOpen(false);
          }}
          isPreviewPlan={
            subscriptionData[0]?.subscription_type === SUBSCRIPTION_TYPE.PREVIEW
          }
        />
      </PopUp> */}
      {/* Delete confirmation popup */}
      <PopUp
        isOpen={isDeleteModalOpen}
        onPopUpCloseClick={() => setIsDeleteModalOpen(false)}
        type={PopupTypes.TYPE2}
      >
        <Stack
          direction="column"
          alignItems="center"
          textAlign="center"
          marginBottom="12px"
        >
          <Typography variant="title1" paddingBottom="12px">
            {/* {t('deleteCardMessage')} */}
            {t('deleteCardTitle')}
          </Typography>
          <Typography paddingBottom="12px" variant="body1">
            {t('deleteCardConfirmation')}
          </Typography>
        </Stack>

        <Stack direction="column" alignItems="stretch" marginBottom="6px">
          <InstavisionButton
            color="inherit"
            sx={{ marginBottom: '12px' }}
            onClick={() => handleDeleteCard(deleteCardId)}
          >
            {/* {t('delete')} */}
            {t('delete')}
          </InstavisionButton>
          <Button
            variant="text"
            color="secondary"
            onClick={() => setIsDeleteModalOpen(false)}
            sx={{ textTransform: 'capitalize' }}
            className="btn-no-focus"
          >
            {/* {t('cancel')} */}
            {t('cancel')}
          </Button>
        </Stack>
      </PopUp>
      {cannotDeleteDefaultCardModelOpen && (
        <CannotDeleteDefaultCardPopup
          isPopUpOpen={cannotDeleteDefaultCardModelOpen}
          setIsPopUpOpen={setCannotDeleteDefaultCardModelOpen}
        />
      )}
    </div>
  );
}

export default PaymentMethod;
